var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component, createRef } from 'react';
import RelativePortal from 'react-relative-portal';
import { AiFillCaretDown } from 'react-icons/ai';
import { ModelToolbarButton } from '@styled/Model';
import { Check } from '@shared/icons/icons';
var ToolbarSelect = /** @class */ (function (_super) {
    __extends(ToolbarSelect, _super);
    function ToolbarSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.dropdownButton = createRef();
        _this.state = {
            show: false,
        };
        _this._setShowAsyncTimer = null;
        _this._handleShow = function () {
            _this._setShowAsync(true);
        };
        _this._handleHide = function () {
            _this._setShowAsync(false);
        };
        return _this;
    }
    ToolbarSelect.prototype.componentDidMount = function () { };
    ToolbarSelect.prototype.componentWillUnmount = function () {
        if (this._setShowAsyncTimer) {
            clearTimeout(this._setShowAsyncTimer);
        }
    };
    ToolbarSelect.prototype._setShowAsync = function (show) {
        var _this = this;
        if (this._setShowAsyncTimer) {
            clearTimeout(this._setShowAsyncTimer);
        }
        this._setShowAsyncTimer = setTimeout(function () {
            _this.setState({ show: show });
        }, 0);
    };
    ToolbarSelect.prototype.handler = function (value) {
        if (value !== this.props.selected) {
            this.props.action(value);
            if (!this.props.multiselect) {
                this._handleHide();
            }
        }
    };
    ToolbarSelect.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var show = this.state.show;
        var _c = this.props, _d = _c.width, width = _d === void 0 ? 100 : _d, selected = _c.selected, options = _c.options, filteringMode = _c.filteringMode, multiselect = _c.multiselect, noDropdownIcon = _c.noDropdownIcon, noCheckIcon = _c.noCheckIcon, label = _c.label;
        return (React.createElement(React.Fragment, null,
            React.createElement(ModelToolbarButton, { className: "toolbar-portal-toggle", "$open": show, style: { minWidth: "".concat(width, "px") }, onClick: show ? this._handleHide : this._handleShow, ref: this.dropdownButton },
                label,
                !noDropdownIcon && React.createElement(AiFillCaretDown, null)),
            React.createElement(RelativePortal, { component: "div", left: this.dropdownButton.current ? -((_a = this.dropdownButton.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) - 1 : 0, top: 38, onOutClick: show ? this._handleHide : undefined }, show && (React.createElement("ul", { style: this.dropdownButton.current
                    ? { minWidth: "".concat((_b = this.dropdownButton.current.offsetWidth) !== null && _b !== void 0 ? _b : +1, "px") }
                    : undefined, className: "toolbar portal-select-content" }, options.map(function (o) {
                var isActive;
                if (!(selected instanceof Array)) {
                    isActive = selected === o.value;
                }
                else {
                    isActive = selected.includes(o.value);
                }
                // Filtering mode - when the option should have the active class if its not active
                if (filteringMode) {
                    isActive = !isActive;
                }
                return (React.createElement("li", { key: o.value, className: isActive ? 'active' : '', onClick: _this.handler.bind(_this, o.value) },
                    !noCheckIcon && React.createElement(Check, null),
                    o.icon ? o.icon : null,
                    o.label));
            }))))));
    };
    return ToolbarSelect;
}(Component));
export default ToolbarSelect;
